// extracted by mini-css-extract-plugin
export default {"POCSkeletonCardWrapper":"poc-skeleton-card_POCSkeletonCardWrapper__67xCf","POCSkeletonCardDetails":"poc-skeleton-card_POCSkeletonCardDetails__2LpIU"};